import React from "react";
import GrabMerchantLogo from "../../assets/images/grab-merchant-v2.svg";
import GrabInitialLogo from "../../assets/images/grab-initial-logo.svg";
import createMenus from "./SidebarMenuV2Data";
import { TROY_SIDE_BAR_NAVIGATION } from "../../constants";

const SidebarLogoV2 = (props) => {
  const { collapsed, handleItemClick, trackTroyAnalytics } = props;
  const logo = collapsed ? GrabInitialLogo : GrabMerchantLogo;
  const menus = createMenus();
  let firstItem = "/dashboard";
  for (let i = 0; i < menus.length; i++) {
    if (menus[i].show) {
      firstItem = menus[i].key;
      break;
    }
  }

  const onClickLogo = () => {
    trackTroyAnalytics(TROY_SIDE_BAR_NAVIGATION, "CLICK_LOGO", null);
    handleItemClick({ key: firstItem });
  };

  return (
    <div className="sidebar-logo-container" data-testid="troyHomeLogo">
      <img
        src={logo}
        alt="Grab Logo"
        style={{ cursor: "pointer" }}
        onClick={onClickLogo}
      />
    </div>
  );
};

export default SidebarLogoV2;
